import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, computed } from 'vue'
import { DateTimeUtil } from './LuxonUtil'
import { DateTime } from 'luxon'


export default /*#__PURE__*/_defineComponent({
  __name: 'RelativeDate',
  props: {
    value: {}
  },
  setup(__props: any) {

const props = __props;



const showRelativeDateRef = ref(true)

const dateTextRef = computed(() => showRelativeDateRef.value 
  ? DateTimeUtil.toRelativeDate(props.value)
  : DateTimeUtil.toUserActionDate(props.value)
)

function toggleRelativeDates() {
  showRelativeDateRef.value = !showRelativeDateRef.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "btn btn-inline btn-link link-dark",
    onClick: toggleRelativeDates
  }, _toDisplayString(dateTextRef.value), 1))
}
}

})